import { Instance } from 'mobx-state-tree';
import { SecretariatStore } from '../../../store';
import { inject, observer } from 'mobx-react';
import React from 'react';
import SelectInputFormField from './SelectInputFormField';
import { IItemRendererProps } from '@blueprintjs/select';
import { MenuItem } from '@blueprintjs/core';
import { TLCode } from '../../../common/enums';
import { toJS } from 'mobx';
import withTranslate, { WithTranslateProps } from '../WithTranslate';
import { Secretariat } from '../../../store/models/Secretariat';

interface SecretariatFormFieldProps extends WithTranslateProps {
  SecretariatStore?: Instance<typeof SecretariatStore>;
  secretariatList?: Array<Instance<typeof Secretariat>>;
}

@inject('SecretariatStore')
@observer
class SecretariatFormField extends React.Component<SecretariatFormFieldProps> {
  renderSecretariatMenuItem(item: Instance<typeof Secretariat>, { handleClick, modifiers }: IItemRendererProps) {
    if (modifiers.matchesPredicate) {
      return (
        <MenuItem
          key={`secretariat-${item.secretariatId}`}
          active={modifiers.active}
          onClick={handleClick}
          text={item.code}
        />
      );
    } else {
      return null;
    }
  }

  filterSecretariat = (query, secretariat) => {
    return secretariat.code.indexOf(query.toLowerCase()) >= 0;
  };

  render() {
    const { secretariatList, SecretariatStore, ...otherProps } = this.props;

    return (
      <SelectInputFormField
        label={TLCode.SECRETARIAT}
        name="secretariatId"
        inline={true}
        items={toJS(secretariatList)}
        itemValueGetter={(item: any) => item.secretariatId}
        valueItemGetter={(value) => SecretariatStore!.getById(value)!}
        inputValueRenderer={(item) => (item !== undefined ? item.code : '')}
        itemRenderer={this.renderSecretariatMenuItem}
        itemPredicate={this.filterSecretariat}
        identifier={'secretariatId'}
        elementLabel={'code'}
        labelSelectAnElement={this.props.translate(TLCode.CHOOSE_A_SECRETARIAT)}
        helperText={this.props.translate(TLCode.CHOOSE_A_SECRETARIAT)}
        placeholderSelection={TLCode.CHOOSE_A_SECRETARIAT}
        {...otherProps}
      />
    );
  }
}

export default withTranslate(SecretariatFormField);
